export const getPreviousCalcs = (calculations: any, datasetId: string, tableIdToPushInto: string) => {
    const nonAggregated = calculations.savedCalculations
      .filter((calc: any) => !calc.isAggregated && calc.datasetId === datasetId && calc.tableId === tableIdToPushInto)
      .map((calc: any) => ({ uuid: calc.uuid, tableId: calc.tableId, ...calc.calculationInfo }));
  
    const aggregated = calculations.savedCalculations
      .filter((calc: any) => calc.isAggregated && calc.datasetId === datasetId)
      .map((calc: any) => ({ uuid: calc.uuid, ...calc.calculationInfo }));
  
    return [nonAggregated, aggregated];
  };